import { attributes, Events } from '@type-r/models';
import { Linked, useModel } from '@type-r/react';
import { CompactTextArea, PopupIODialog, SelectFile, toLinkedBoolean } from 'lqx-react';
import * as React from 'react';
import { Reconciliation } from 'src/app/pages/inmatch/api';
import { InlinePaymentHeader } from '../unreconciled/payment-header';

const LocalState = attributes({
    comment : String,
    file : null
});

export const UnreconcileDialog = ({ $reconciliation, $refresh } : {
    $reconciliation : Linked<Reconciliation>,
    $refresh : Linked<boolean> 
}) => {
    const local = $reconciliation.value,
        state = useModel( LocalState );

    return (
        <PopupIODialog
            $isOpen={ toLinkedBoolean( $reconciliation ) }
            title="Are you sure you want to unmatch?"
            actionLabel="Unmatch"
            success="Reconciliation is unmatched"
            disabled={ false }
            doIO={ async () => {
                await local.destroy({ params: { file: state.file, comment: state.comment }});
                Events.trigger( "summary:refresh" );
                $refresh.set(!$refresh.value);
                // TODO: uploads
            }}
        >
            <InlinePaymentHeader payment={ local } isValid={() => true} currency={ local.currency } />

            <CompactTextArea label="Comments"
                $value={state.$.comment}
            />

            <SelectFile label="Attachment"
                accept=".csv,.edi,.xml,.txt,.json,.pdf,.xls,.doc,.docx,.xlsx,.png,.jpeg,.msg"
                $value={ state.$.file }
            />
        </PopupIODialog>
    )
}

